import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface CreateOccasionRequest {
  title: string;
  date: string;
}

interface CreateOccasionResponse {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  date: string;
  created_at: string;
  updated_at: string;
}

export function useCreateOccasion(relationshipId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateOccasionRequest) => {
      const response = await api
        .post(`relationships/${relationshipId}/occasions`, { json: data })
        .json<CreateOccasionResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.relationship.byId(relationshipId),
      });
    },
  });
}
